import { useNavigate } from 'react-router-dom'

import Pagination from '@10xLabs/react-web/components/Pagination'
import { PaginationCaption } from 'features/App/components/PaginationCaption'
import { getDateRangeQuery } from 'utils/date'
import { getQueryString } from 'utils/route'
import { ReactElement } from 'react'
import { IBookingFilters } from 'features/Bookings/views/Index/Filters/types'

interface IBookingsPaginationProps {
  page: number
  totalItems: number
  limit: number
  currentItemsCount: number
  filters: IBookingFilters
}

export const BookingsPagination = ({
  page,
  totalItems,
  limit,
  currentItemsCount,
  filters
}: IBookingsPaginationProps): ReactElement => {
  const navigate = useNavigate()

  const setPage = (page: number): void => {
    const travelDateRangeQuery = getDateRangeQuery(filters.travelDateRange)
    const purchaseDateRangeQuery = getDateRangeQuery(filters.purchaseDateRange)
    const sortingDateRangeQuery = getDateRangeQuery(filters.sortingDateRange)

    const query = {
      page,
      email: filters.email,
      emailStatus: filters.emailStatus,
      travelDateFrom: travelDateRangeQuery.from,
      travelDateTo: travelDateRangeQuery.to,
      travelDateRangeValue: travelDateRangeQuery.rangeValue,
      purchaseDateFrom: purchaseDateRangeQuery.from,
      purchaseDateTo: purchaseDateRangeQuery.to,
      purchaseDateRangeValue: purchaseDateRangeQuery.rangeValue,
      sortingDateFrom: sortingDateRangeQuery.from,
      sortingDateTo: sortingDateRangeQuery.to,
      sortingDateRangeValue: sortingDateRangeQuery.rangeValue,
      origin: filters.origin && filters.origin.id,
      destination: filters.destination && filters.destination.id,
      site: filters.site && filters.site.id,
      status: filters.status.join(','),
      reservations: filters.reservations.join(','),
      buyerPhone: filters.buyerPhone,
      salesChannelId: filters.salesChannel?.id,
      companyLineId: filters.companyLine?.id,
      routeServiceIds: filters.routeServices.map(({ id }) => id).join(',')
    }

    navigate(`/bookings?${getQueryString(query)}`)
  }

  return (
    <Pagination.Container>
      <Pagination.Caption
        page={page}
        totalItems={totalItems}
        currentItemsCount={currentItemsCount}
        limit={limit}
        getCaptionMessage={(firstItemIndex: TSFixMe, lastItemIndex: TSFixMe): TSFixMe => (
          <PaginationCaption firstItemIndex={firstItemIndex} lastItemIndex={lastItemIndex} totalItems={totalItems} />
        )}
      />

      <Pagination.Previous page={page} setPage={setPage} />

      <Pagination.Next page={page} totalItems={totalItems} limit={limit} setPage={setPage} />
    </Pagination.Container>
  )
}
